<template>
  <body class="mob-overflow">
    <div class="symptomchk_mainview_div">
      <header class="mob-display common--header">
      <b-row class="marginTopAlignment">
        <b-col cols="2" v-on:click="backAction()"><img src="images/Back_white.svg" alt=""/></b-col>
        <b-col cols="8" class="header-title text-center">HEALTH SURVEY</b-col>
      </b-row>
    </header>

     <header class="desk_display">
        <div id="header_content" class="common--header">
          <p class="alignleft"></p>
          <p class="aligncenter header-title">HEALTH SURVEY</p>
          <p class="alignright" v-on:click="gomenu()">
            <img src="images/Home@2x.png" alt v-b-toggle.sidebar-backdrop />
          </p>
        </div>
        <div style="clearaligncenter: both;"></div>
      </header>

      <!-- <header class="resrc_common--header">
        <b-row class="marginTopAlignment">
          <b-col cols="2" class="mob-display" v-on:click="backAction()">
            <img src="images/Back_white.svg" alt />
          </b-col>
          <b-col cols="11" class="desk_display header-title text-center">HEALTH SURVEY</b-col>
          <b-col cols="8" class="mob-display header-title text-center">HEALTH SURVEY</b-col>
          <b-col
            cols="1"
            v-on:click="gomenu()"
            class="centering-block desk_display textalign_right"
          >
            <img src="images/Home@2x.png" alt v-b-toggle.sidebar-backdrop /> 
          </b-col>
        </b-row>
      </header> -->
      <b-container class="bv-example-row symptomchk_cont_height mob_col_padding">
        <b-row class="justify-content-md-center mob_lr_margin row_height">
          <!-- <b-col lg="12" class="symptomContent mob_col_padding dev_position"> -->
          <b-col lg="12" class="mob_col_padding dev_position">
            <div class="checkerListDiv">
              <b-row>
                <label class="checkerHeading">{{ this.healthSurvey }}</label>
              </b-row>
              <b-row>
                <div class="symptomStaticMessage">
                  <p class="cdcHyperLink">
                    Symptom questions are per
                    <a href="javascript:void(0);" @click="goCDCPage" class>
                      <b>CDC Guidelines</b>
                    </a>
                  </p>
                  <p>{{ this.healthSurveySubText }}</p>
                  <ul>
                    <li>{{ this.healthSurveyList1 }}</li>
                    <li>{{ this.healthSurveyList2 }}</li>
                    <li>{{ this.healthSurveyList3 }}</li>
                    <li>{{ this.healthSurveyList4 }}</li>
                  </ul>
                </div>
              </b-row>
              <b-row>
                <label class="checkerSubHeading">{{ this.selectManyOptions }}</label>
              </b-row>
            </div>
            <b-row>
              <b-col>
                <div class="symptomsList">
                  <b-form @submit="onSubmit">
                    <b-container>
                      <div
                        class="checkbox-div checkboxBgStyle"
                        v-for="item in Items"
                        v-bind:key="item.sid"
                        :id="item.sid"
                      >
                        <div>
                          <label class="form-collapse-label">
                            <input
                              type="checkbox"
                              class="Symptoms_checkbox"
                              name="symptomCheckbox"
                              v-on:click="onSelectOption(item, $event)"
                              v-model="user.symptom_checker"
                        :id="item.sid"
                        :value="item.sid"
                            />
                            {{ item.snm }}
                          </label>
                          <label
                            class="healthSurveyArrowBGLabel buttonhighlight"
                            v-b-toggle="'id-' + item.sid"
                            v-if="item.sid != 'N00001'"
                          >
                          <span class="when-closed">
                              <img class="healthSurveyArrowImage buttonhighlight" src="images/Down_arrow.png"/>
                          </span>
                          <span class="when-opened">
                              <img class="healthSurveyArrowImage buttonhighlight" src="images/Up_arrow.png"/>
                          </span>
                          </label>
                        </div>
                        <b-collapse :id="'id-' + item.sid" v-if="item.sid != 'N00001'" :visible="item.exp" >
                          <b-card class="form-collapse-detail-label" :for="item.sid">{{ item.desc }}</b-card>
                        </b-collapse>
                      </div>
                      <div class="footer_bottom">
                      <b-row align-h="center">
                        <!-- <b-col class="col-lg-4"> -->
                           <b-col class="xs_col col-sm-10 col-md-7 col-lg-5">
                          <div class="symptomchk_app--btn text-center">
                            <label
                              v-if="errorStatus"
                              class="login_errorMessageLabel"
                              id="errorLabel"
                            >{{ errorMessage }}</label>
                            <a href="javascript:void(0);" @click="onSubmit" class="app--btn">SUBMIT</a>
                          </div>
                        </b-col>
                      </b-row>
                      </div>
                    </b-container>
                  </b-form>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <!-- <div class="mob-display buttonBottomAlign">
        <b-row align-h="center"> -->
          <!-- <b-col class="col-lg-3">
            <div class="symptomchk_app--btn text-center"> -->
           <!-- <b-col class="xs_col col-sm-12 col-md-12 col-lg-12 col_padding">
              <div class="btn-container_SpaceAdjusted text-center">
              <label
                v-if="errorStatus"
                class="login_errorMessageLabel"
                id="errorLabel"
              >{{ errorMessage }}</label>
              <a href="javascript:void(0);" @click="onSubmit" class="app--btn">SUBMIT</a>
            </div>
          </b-col>
        </b-row>
      </div> -->
      <b-modal ref="back-modal" class="verticalCenterAlign" centered hide-header hide-footer>
        <div class="d-block text-center">
          <label class="surveyPopUpText">{{ this.healthSurveyBackPopup }}</label>
          <br />
          <br />
        </div>
        <div class="rightAlign">
          <a href="javascript:void(0);" @click="exitModal" class="exitHyperLinkStyle">{{ this.yes }}</a>
          <a href="javascript:void(0);" @click="hideModal" class="exitHyperLinkStyle">{{ this.no }}</a>
        </div>
      </b-modal>
      <b-modal ref="error-modal" class="verticalCenterAlign" centered hide-header hide-footer>
        <label class="surveyPopUpText">{{ this.healthSurveyNoSymptomPopup }}</label>
        <br />
        <br />
        <div class="rightAlign">
          <a href="javascript:void(0);" @click="hideModal" class="exitHyperLinkStyle">{{ this.ok }}</a>
        </div>
      </b-modal>
    </div>
    <Footer></Footer>
  </body>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Footer from "@/components/footer";
// import moment from "moment";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      Items: "",
      user: {
        symptom_checker: [],
      },

      store: store,
      selectedSymptom: {
        iid: store.registration.iid,
        gid: store.groupDetail.gid,
        syms: [],
      },
      symptomDetail: {},
      checkboxSelected: [],
      isSelected: false,
      errorStatus: false,
      errorMessage: "",
    };
  },
  methods: {
    goCDCPage() {
      window.open(this.healthSurveyCDCURL, "_blank");
    },
    backAction() {
      if (this.user.symptom_checker.length > 0) {
        this.$refs["back-modal"].show();
      } else {
        this.$router.push({ path: "/app-home" });
      }
    },
    gomenu() {
      this.$router.push({ path: "/app-home" });
    },
    hideModal() {
      this.$refs["error-modal"].hide();
      this.$refs["back-modal"].hide();
    },
    exitModal() {
      this.$router.push({ path: "/app-home" });
    },
    onSubmit(evt) {
      evt.preventDefault();

      var optionSelected = false;

      for (var i = 0; i < this.Items.length; i++) {
        for (var j = 0; j < this.user.symptom_checker.length; j++) {
          if (this.Items[i].sid == this.user.symptom_checker[j]) {
            this.selectedSymptom.syms.push({
              sid: this.Items[i].sid,
              answ: true,
              cat: this.Items[i].cat,
            });
          }
        }
      }

      if (this.user.symptom_checker.length > 0) {
        optionSelected = true;
      }

      if (optionSelected) {
        if (navigator.onLine) {
        this.errorStatus = false;
        var header = {};
        //   headers: [
        //     {
        //       key: "Content-Type",
        //       value: "application/json",
        //       type: "text",
        //     },
        //   ],
        // };
        
        apiCall
          .apiServiceCall("Post", "", "/survey", this.selectedSymptom, header)
          .then(response => {
            console.log("Response:",response);
              if (response.data.status == 1) {
                store.symptomChkResponse = response.data;
                this.$router.push({ path: "/symptom-chk-success" });
              } else {
                this.errorStatus = true;
                this.errorMessage = response.data.message;
              }
          })
          .catch(error => {
            if (error.response.status == 500) {
              this.errorStatus = true;
              this.errorMessage = this.serverProblem;
            } else if (error.response.status == 401) {
              setTimeout(() => this.$router.push({ path: "/home" }), 2000);
            } else if (error.response.status == 504) {
              this.signout();
            }  else {
              this.errorStatus = true;
              this.errorMessage = error.response.data.message;
            }
          });

        } else {
          this.errorStatus = true;
          this.errorMessage = this.checkInternetConnection;
        }
      } else {
        this.$refs["error-modal"].show();
      }
    },
    onClear() {
      this.$refs["back-modal"].show();
    },
    onSelectOption(symptom, event) {
      if (event.target.checked) {
        this.checkboxSelected.push(symptom.sid);

        if (symptom.sid == "N00001") {
          this.user.symptom_checker = [];
          for (let i = 0; i < this.checkboxSelected.length; i++) {
            var id = this.checkboxSelected[i];
            setTimeout(() => (document.getElementById(id).checked = false), 2000);
            document.getElementById(this.checkboxSelected[i]).className = "checkbox-div checkboxBgStyle";
          }
          this.user.symptom_checker.push(symptom.sid);
          document.getElementById(symptom.sid).className = "checkbox-div-WithBackground checkboxBgStyle";
        } else {
          this.user.symptom_checker.push(symptom.sid);
          document.getElementById(symptom.sid).className = "checkbox-div-WithBackground checkboxBgStyle";
          for (let i = 0; i < this.user.symptom_checker.length; i++) {
            if (this.user.symptom_checker[i] == "N00001") {
              this.user.symptom_checker.splice(this.user.symptom_checker.indexOf("N00001"), 1);
              setTimeout(() => (document.getElementById("N00001").checked = false), 2000);
              document.getElementById("N00001").className = "checkbox-div checkboxBgStyle";
              console.log("for - if", this.user.symptom_checker);
            }
          }
        }
      } else {
        this.user.symptom_checker.splice(this.user.symptom_checker.indexOf(symptom.sid), 1);
        document.getElementById(symptom.sid).className = "checkbox-div checkboxBgStyle";
      }
    },
  },
  mounted() {
    if (navigator.onLine) {
    apiCall
      .apiServiceCall("Get", "", "/symptom/", "", "")
      .then(response => {

          if (response.data.status == 1) {
            this.Items = response.data.data;
          } else {
            this.errorStatus = true;
            this.errorMessage = response.data.message;
          }
      })
      .catch(error => {
        if (error.response.status == 500) {
          this.errorStatus = true;
          this.errorMessage = this.serverProblem;
        } else if (error.response.status == 401) {
          setTimeout(() => this.$router.push({ path: "/home" }), 2000);
        } else if (error.response.status == 504) {
            this.signout();
        }  else {
          this.errorStatus = true;
          this.errorMessage = error.response.data.message;
        }
      });

    } else {
      this.errorStatus = true;
      this.errorMessage = this.checkInternetConnection;
    }
  },
};
</script>
<style scoped>
  .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

</style>